<template>
  <div class="main">
     <div class="bomMain">
        <!-- <div class="centerBox">
          <van-dropdown-menu active-color="#1989fa">
            <van-dropdown-item v-model="value1" :options="option1" @change="searchCanteen" />
            <van-dropdown-item v-model="value2" :options="option2" @change="searchCanteen" />
            <van-dropdown-item v-model="value3" :options="option3" @change="searchCanteen" />
          </van-dropdown-menu>
        </div> -->
        <div style="height:15px;"></div>
        <div class="bottomBox">
          <ul v-if="canteenList.length>0">
        <li v-for="(item,index) in canteenList" :key="index" @click="changetToPath(item.id)">
           <!-- <div class="leftBox">
            <img :src="imgUrl+item.cShowPicture" :onerror="defaultImg" alt="">
          </div> -->
          <div class="rightBox">
            <div class="rightCenter">
              <div class="rightCenterLeft">
                <div class="rightTil">{{item.cCanteenName}}</div>
              </div>
              <div class="rightCenterRight">
                <!-- <div style="margin-right:8px">30分钟</div> -->
                <!-- <div>{{(item.distance/1000).toFixed(2)}}km</div> -->
                <div class="phoneIcon"><img src="../assets/navIcon.png" alt=""></div>
                <div style="color:#3B87F5;font-size: 14px;margin-right: 10px;" @click.stop="changeToNav(item.cLongitude,item.cLatitude,item.cDetailedAddress)">导航</div>
              </div>
            </div>
            <div class="rightCenter">
              
              <div class="rightCenterRight">
                <!-- <div style="margin-right:8px">30分钟</div> -->
                <div class="phoneIcon"><img src="../assets/phoneIcon.png" alt=""></div>
                <div style="color:#3B87F5;font-size: 14px;margin-right: 10px;" @click.stop="getCall(item.cPhone)">{{item.cPhone}}</div>
                <div style="color:#3B87F5;font-size: 14px;" @click.stop="getCall(item.cLandlineNumber)">{{item.cLandlineNumber}}</div>
                <!-- <div class="bomBtn" @click.stop="showModel=true;id=item.id">就餐预约</div> -->
              </div>
              <div style="color: #999999;font-size:14px;">{{(item.distance/1000).toFixed(2)}}km</div>
            </div>
            <div class="rightBottom" >
              <div class="rightCenterLeft">
                <div class="starList">
                  <div class="starBox" v-for="(itemsss,index) in 5" :key="index">
                    <img :src="index<parseInt(item.avgEvaluate-0)?require('../assets/star.png'):require('../assets/star_active.png')" alt="">
                  </div>
                </div>
                <div class="score">{{parseInt(item.avgEvaluate-0)}}分</div>
              </div>
              <div class="bomBtn" @click.stop="showModel=true;id=item.id">就餐预约</div>
            </div>
          </div>
        </li>
      </ul>
      <div v-else style="padding:60px 0 0;text-align:center;">暂无数据</div>
        </div>
      </div>
      <div style="height:20px"></div>

      <van-popup v-model="showModel" closeable round position="bottom">
      <div class="modelBox">
        <div class="modelTil">预约就餐</div>
        <div class="bomBox">
          <van-tabs type="card" color="#3B87F5" v-model="activeName">
            <van-tab title="一人就餐" name="一人就餐">
              <van-cell-group>
                <van-field v-model="unitDep" readonly label="单位部门" placeholder=""/>
                <van-field v-model="selectDate" is-link readonly label="预约时间" placeholder="请选择预约时间" @click="dateShow = true"/>
                <van-field v-model="eatName" label="预定人名称" placeholder="请输入预定人姓名" />
                <van-field v-model="eatPhone" type="tel" label="电话" placeholder="请输入联系电话" />
              </van-cell-group>
            </van-tab>
            <van-tab title="多人就餐" name="多人就餐">
              <van-cell-group>
                <van-field v-model="eatNum" type="digit" label="就餐人数" placeholder="请输入就餐人数" />
                <van-field v-model="unitDep" readonly label="单位部门" placeholder=""/>
                <van-field v-model="selectDate" is-link readonly label="预约时间" placeholder="请选择预约时间" @click="dateShow = true"/>
                <van-field v-model="eatName" readonly label="预定人名称" placeholder="请输入预定人姓名" />
                <van-field v-model="eatPhone" type="tel" label="电话" placeholder="请输入联系电话" />
              </van-cell-group>
            </van-tab>
          </van-tabs>
        </div>
      </div>
      <div class="bomBtn1">
        <div class="leftBtn" @click="showModel = false">取消</div>
        <div class="rightBtn" @click="subscribeFood">确认</div>
      </div>
    </van-popup>
    <van-popup v-model="dateShow" round position="bottom">
      <van-datetime-picker
      v-model="currentDate"
      type="datetime"
      title="选择完整时间"
      :min-date="minDate"
      :max-date="maxDate"
      visible-item-count="5"
      @cancel="dateShow = false" 
      @confirm="confirmDate"
    />
    </van-popup>
    <van-action-sheet v-model="showNav" :actions="actions" @select="onSelectNav" :close-on-click-overlay="false" cancel-text="取消"/>
  </div>
</template>

<script>
import qs from 'qs'
import Vue from 'vue';
import { Search } from 'vant';
import { DropdownMenu, DropdownItem } from 'vant';
import { Toast } from 'vant';
import { Dialog } from 'vant';
import { addBaseAplus } from '../utils/zzdmd.js'
// 全局注册
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Search);
export default {
  name: 'collection',
  data () {
    return {
      value:'',
      historyShow:true,
      value1: '',
      value2: '',
      value3: '',
      option1: [],
      option2: [],
      option3: [],
      countList:[],
      streetList:[],
      countIdx:0,
      streeIdx:'',
      canteenList:[],
      showModel:false,
      value:'',
      minDate: new Date(),
      maxDate: new Date(new Date().getFullYear()-0+3, 1, 1),
      currentDate: new Date(),
      dateShow:false,
      eatNum:'',
      eatName:'',
      eatPhone:'',
      selectDate:'',
      unitDep:'',
      UnitsID:'',
      activeName:'一人就餐',
      id:'',
      historySearch:[],
      actions: [ { name: '高德地图' }],
      showNav:false,
      tlon:0,
      tlat:0,
      taddress:'',
      lon:sessionStorage.getItem('userLon'),
      lat:sessionStorage.getItem('userLat'),
      address:sessionStorage.getItem('userAddress')
    }
  },
   created(){
    this.searchCanteen()
    this.selectDate = this.getnow()
    this.getUserInfo()
  },
  mounted(){
    addBaseAplus(this.$route)
  },
  activated(){
    this.searchCanteen()
    this.selectDate = this.getnow()
    this.getUserInfo()
  },
  methods:{
    getCanteenOreder(){
      this.option1 = []
      this.option2 = []
      this.option3 = []
      let param = {}
      this.$post('api/Canteen/GetCanteenOrderType', qs.stringify(param),{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        if(res.code==1000){
          res.data.zList.map((item)=>{
            this.option1.push({
              text:item.key,
              value:item.value
            })
          })
          this.value1 = this.option1[0].value
          res.data.jList.map((item)=>{
            this.option2.push({
              text:item.key,
              value:item.value
            })
          })
          this.value2 = this.option2[0].value
          res.data.xList.map((item)=>{
            this.option3.push({
              text:item.key,
              value:item.value
            })
          })
          this.value3 = this.option3[0].value
          // this.getCanteenList()
        }
      })
    },
    clearSearchAll(){
      if(this.historySearch.length<=0){
        return
      }
      Dialog.confirm({
        title: '提示',
        message: '确认删除全部搜索记录吗？',
        confirmButtonColor:'#3B87F5',
      }).then(() => {
          this.historySearch = []
          localStorage.setItem('historySearch',JSON.stringify(this.historySearch))
        }).catch(() => {
          // on cancel
        });
    },
    changeValue(){
      if(this.value==''){
        this.historyShow = true
      }
    },
    clearAllVal(){
      this.value = ''
      this.changeValue()
    },
    changeSearchVal(val){
      this.value = val
      this.searchCanteen()
    },
    searchCanteen(){
      let param = {
        longitude:sessionStorage.getItem('userLon'),
        latitude:sessionStorage.getItem('userLat'),
        // WorkerID:11
        WorkerID:JSON.parse(sessionStorage.getItem('userData')).workerID,
      }
      this.$post('api/Canteen/GetCanteenList', qs.stringify(param),{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        if(res.code==1000){
            this.canteenList = res.data
        }else{
          Toast({
          message: res.msg||res.message,
          position: 'bottom',
          })
        }
      })
    },
    changetToPath(id){
      this.$router.push({path:'/canteenDetail',query:{id:id}})
    },
    changeToSearch(){
      this.$router.push({path:'/search'})
    },
    getUserInfo(){
      let param = {
        WorkerID:JSON.parse(sessionStorage.getItem('userData')).workerID,
        // WorkerID:11
      }
       this.$post('api/User/GetUserUnitsAndName', qs.stringify(param),{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        if(res.code==1000){
          this.eatName = res.data.name
          this.unitDep = res.data.unitsName
          this.UnitsID = res.data.unitsID
        }
      })
    },
    isPoneAvailable(phone) {
        let myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (!myreg.test(phone)) {
            return false
        } else {
            return true
        }
    },
    subscribeFood(){
      let num = 1
      if(this.activeName=='多人就餐'){
        num = this.eatNum
        if(!(this.eatNum-0)){
          Toast({
          message: '用餐人数不正确',
          position: 'bottom',
          })
          return
        }
      }
      if(this.eatPhone == ''){
            Toast({
            message: '请输入手机号',
            position: 'bottom',
            })
            return
        }
        if(!this.isPoneAvailable(this.eatPhone)){
            Toast({
            message: '请输入正确的手机号',
            position: 'bottom',
            })
            return
        }
        dd.showLoading({
          text: "", //提示信息
        })
      let param = {
        boWorkerID:JSON.parse(sessionStorage.getItem('userData')).workerID,
        // boWorkerID:'11',
        boAppointment:this.selectDate,
        boBookingPerson:this.eatName,
        boDiningType:this.activeName,
        boNumber:num,
        boPhone:this.eatPhone,
        boUnitsID:this.UnitsID,
        boCanteenID:this.id,

      }
       this.$post('api/Canteen/SubscribeFood', qs.stringify(param),{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        dd.hideLoading({})
        if(res.code==1000){
          this.dateShow = false
          this.showModel = false
          Toast({
          message: '预约成功',
          position: 'bottom',
          })
        }else{
          Toast({
          message: res.msg||res.message,
          position: 'bottom',
          })
        }
      })
    },
    confirmDate(e){
      this.selectDate = this.getnow(e)
      this.dateShow = false
    },
    getnow(dates){
      var mynow = dates?new Date(dates):new Date();//默认的获取的是当前时间
      //通过调用日期对象的方法来重新获取当前的日期时间
      //mynow.setFullYear(2016);
      var year = mynow.getFullYear();//获取年
      var month = (mynow.getMonth()+1)<10?'0'+(mynow.getMonth()+1):(mynow.getMonth()+1);//获取月
      var day = mynow.getDate()<10?'0'+mynow.getDate():mynow.getDate();//获取日
      var hour =mynow.getHours()<10?'0'+mynow.getHours():mynow.getHours();//获取小时
      var minute =mynow.getMinutes()<10?'0'+mynow.getMinutes():mynow.getMinutes();//获取分钟
      // var second =mynow.getSeconds();//获取秒
      var strdate = year+'-'+ month+"-"+day+' '+hour+':'+minute
      return strdate
    },
    getCall(phone){
      dd.callPhone({
          phoneNum: phone,//电话号码
      }).then(res => {
          console.log(res)
      }).catch(err => {})
    },
    changeToNav(tlon,tlat,taddress){
      this.tlon = tlon
      this.tlat = tlat
      this.taddress = taddress
      this.showNav = true
    },
    onSelectNav(item){
      if(item.name=='百度地图'){
        // dd.openLink({
        //     url: `http://api.map.baidu.com/direction?origin=latlng:${this.lat},${this.lon}|name:${this.address}&destination=latlng:${this.tlat},${this.tlon}|name:${this.taddress}&mode=driving&coord_type=gcj02&src=webapp.baidu.openAPIdemo`
        // }).then(res => {
        //     console.log(res)
        // }).catch(err => {})
      }else if(item.name=='高德地图'){
        dd.openLink({
            url: `https://uri.amap.com/navigation?from=${this.lon},${this.lat},${this.address}&to=${this.tlon},${this.tlat},${this.taddress}&coordinate=gaode&callnative=1`
        }).then(res => {
            console.log(res)
        }).catch(err => {})
      }
      this.showNav = false
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main{
  background: #f2f2f2;
    min-height: 100vh;
    position: relative;
}
.search{
  box-sizing: border-box;
  padding: 15px 12px;
}
div /deep/ .van-search{
  padding: 0 12px 0 0;
  border-radius: 17px;
  overflow: hidden;
}
div /deep/ .van-search__content{
  background-color: #fff;
}
.history{
  box-sizing: border-box;
  padding: 0 12px;
}
.historyTop{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.historyTil{
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}
.delBtn{
  width: 12px;
  height: 12px;
}
.delBtn>img{
  width: 100%;
  height: 100%;
}
.historyBom{
  box-sizing: border-box;
  padding: 7px 0;
}
.historyBom>ul{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.historyBom>ul>li{
  font-size: 12px;
  font-weight: 500;
  color: #333333;
  box-sizing: border-box;
  padding: 10px 15px;
}
.bomMain{
  width: 100%;
  box-sizing: border-box;
}

.centerBox{
  box-sizing: border-box;
  padding: 0 12px;
}
div /deep/ .van-dropdown-menu__bar{
  background: #f2f2f2;
  box-shadow: none;
}
.bottomBox{
  width: 100%;
  box-sizing: border-box;
  padding: 0 12px;
}
.bottomBox>ul>li{
  width: 100%;
  background: #FFFFFF;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
}
.leftBox{
  width: 60px;
  height: 60px;
  border-radius: 5px;
  overflow: hidden;
}
.leftBox>img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.rightBox{
  width: 100%;
  margin-left: 10px;
}
.rightTil{
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.rightCenter{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 10px 0;
}
.rightCenter1{
  width: 100%;
  margin: 0 0 10px 0;
}
.rightCenterLeft{
  display: flex;
  align-items: center;
}
.starList{
  display: flex;
  align-items: center;
  margin-right: 15px;
}
.starBox{
  display: flex;
  align-items: center;
}
.starBox>img{
  width: 12px;
  height: 12px;
  margin-right: 6px;
}
.score{
  font-size: 12px;
  font-weight: 800;
  color: #FF9023;
}
.rightCenterRight{
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: #999999;
}
.rightBottom{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bomBtn{
  width: 75px;
  height: 26px;
  background: #3B87F5;
  border-radius: 5px;
  line-height: 26px;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  color: #FFFFFF;
}
.modelBox{
  width: 100%;
  box-sizing: border-box;
  padding: 15px 12px 0;
}
.modelTil{
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  text-align: center;
}
.bomBox{
  margin-top: 15px;
}
.bomBtn1{
  margin-top: 20px;
  display: flex;
  align-items: center;
  border-top: 1px solid #ddd;
}
.leftBtn{
  width: 50%;
  height: 49px;
  text-align: center;
  line-height: 49px;
  background-color: #fff;
  font-size: 16px;
  font-weight: 500;
  color: #666666 ;
}
.rightBtn{
  width: 50%;
  height: 49px;
  text-align: center;
  line-height: 49px;
  background-color: #3B87F5;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}
.phoneIcon{
  width: 14px;
  height: 14px;
  margin-right: 5px;
}
.phoneIcon>img{
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/collection.vue